import { Box, Button, Container,  FormControl, Input, InputLabel, Snackbar, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import BoxSettingsContent from '../../components/box/BoxSettingsContent';
import { collapsedDrawerWidth, drawerWidth } from '../../components/navigation/SettingsDrawer';
import { GetSessionData } from '../../services/AuthService';
import { GetReferralData, SendReferralEmail, UpdateAllowedReferralCount } from '../../services/SettingsService';
import { Alert } from './OnboardingSettingsPage';

export default function ReferralSettingsPage() {
  const [numberOfInvites, setNumberOfInvites] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [emailSentSnackbarOpen, setEmailSentSnackbarOpen] = useState<boolean>(false);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [referralsEnabled, setReferralsEnabled] = useState<boolean>(false);
  const [invitationsLeft, setInvitationsLeft] = useState<number>(0);
  const [emailValue, setEmailValue] = useState<string>('');
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState<boolean>(false);

  const handleSnackbarClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleEmailSnackbarClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setEmailSentSnackbarOpen(false);
  };

  const handleSettingsDataUpdate = (response) => {
    setNumberOfInvites(response.n_allowed_referrals);
    setReferralsEnabled(response.enabled_referral);
    setInvitationsLeft(response.invitations_left);
  }

  const updateNumReferrals = () => {
    const settingsData = UpdateAllowedReferralCount(numberOfInvites);
    settingsData.then(res => {
      setSnackbarOpen(true);
    });
  }

  const handleSendEmailButtonClick = () => {
    // prevent double click submit
    setSubmitButtonDisabled(true);
    setTimeout(() => {
      setSubmitButtonDisabled(false);
    }, 3000);

    const req = SendReferralEmail(emailValue);
    req.then(res => {
      if (res.success) {
        setInvitationsLeft(invitationsLeft - 1);
        setEmailSentSnackbarOpen(true);
      }
    });
  };

  useEffect(() => {

    const req = GetSessionData();
    req.then(res => {
      setIsAdmin(res.is_admin);
      const settingsData = GetReferralData(res.is_admin);
      settingsData.then(res => {
        handleSettingsDataUpdate(res);
      });
    })
  }, []);

  let content = isAdmin ?
    <>
      <Box
        sx={{
          '& > :not(style)': { m: 1 },
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography variant='h6'>
          Every user can invite:
        </Typography>
        <FormControl variant="standard" sx={{ width: '300px' }}>
          <InputLabel color="secondary" htmlFor="inviteNumber">Invites:</InputLabel>
          <Input
            id="linksOnPageNumber"
            defaultValue={1}
            value={numberOfInvites}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setNumberOfInvites(Number(event.target.value));
            }}
            color="secondary"
          // type="number"
          />
        </FormControl>
        <Button color='secondary' variant='outlined' sx={{ ml: '3px', mr: '3px', width: '300px' }} onClick={updateNumReferrals}>Update</Button>
        <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity="success" icon={false} sx={{ width: '100%' }}>
            Number of Allowed Referrals Updated!
          </Alert>
        </Snackbar>
      </Box>
    </>
    :
    <Box>
      {referralsEnabled ? (
        <>
          {invitationsLeft > 0 ? (
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant='h6'>
                You have {invitationsLeft} invitations left. You can invite new users by email:
              </Typography>

              <FormControl variant="standard" sx={{ width: '300px', mt: 2 }}>
                <InputLabel color="secondary" htmlFor="inviteNumber">Invites:</InputLabel>
                <Input
                  id="email-field"
                  value={emailValue}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setEmailValue(event.target.value);
                  }}
                  color="secondary"
                />
              </FormControl>
              <Button disabled={submitButtonDisabled || invitationsLeft < 1} color='secondary' variant='outlined' sx={{ ml: '3px', mr: '3px', mt: 2, width: '300px' }} onClick={handleSendEmailButtonClick}>Send</Button>
              <Snackbar open={emailSentSnackbarOpen} autoHideDuration={3000} onClose={handleEmailSnackbarClose}>
                <Alert onClose={handleEmailSnackbarClose} severity="success" icon={false} sx={{ width: '100%' }}>
                  Invitation Email Sent!
                </Alert>
              </Snackbar>
            </Box>
          ) : (
            <Typography variant='h6' sx={{ mt: 4 }}>
              Unfortunately you have used all available invitations. <br /> Please come back later and check for new invitations.
            </Typography>
          )}
        </>
      ) : (
        <Typography variant='h6'>
          Inviting new users to join Scholar inbox will become available 7 days after your registration and after you vote for more than 50 papers!
        </Typography>

      )}
    </Box>;

  return (
    <BoxSettingsContent fullWidth={true}>
      <Container maxWidth="lg" sx={{ my: 4 }}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
            ml: {
              md: `${drawerWidth}px`,
              xs: `${collapsedDrawerWidth}px`,
              xl: '0px',
            },
            width: {
              md: `calc(100% - ${drawerWidth}px)`,
              xs: `calc(100% - ${collapsedDrawerWidth}px)`,
              xl: '100%',
            }
          }}
        >
          {content}
        </Box>
      </Container>
    </BoxSettingsContent>
  )
}